<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Platform | Contact</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
    </Head>
    <!-- content start -->
    <div class="pt-20">
      <h1 class="text-center">Contact Page</h1>
    </div>
  </div>
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
export default {
  layout: DefaultLayout
};
</script>
